import './pranzi2/style';
import FormStructure from './pranzi2/form_structure';

export default FormStructure;